import { useMutation, UseMutationOptions } from "react-query";
import { GATEWAY_URL } from "@/fetch/profiles/constants";
import { usePersonalDetailsQuery } from "@/fetch/profiles";
import useFetchWithAuth from "@/fetch/fetchWithAuth";

type EmploymentHistoryItem = Partial<{
  title: string | null;
  company: string | null;
  website: string | null;
  date_from: number | null;
  date_to: number | null;
  duties: Array<{ details?: string }>;
}>;

type EmploymentHistory = Array<EmploymentHistoryItem>;

type UpdateEmploymentHistoryVariables = {
  employmentHistory: EmploymentHistory;
  resumeId?: number;
};

type UpdateEmploymentHistoryResult = {
  cid: number;
  resumeId: number;
  success: boolean;
};

type QueryError = {};

const useUpdateEmploymentHistoryMutation = (
  options?: UseMutationOptions<
    UpdateEmploymentHistoryResult,
    QueryError,
    UpdateEmploymentHistoryVariables
  >
) => {
  const { fetchWithAuth, cancel } = useFetchWithAuth();
  const { data: personalDetails } = usePersonalDetailsQuery();

  return {
    ...useMutation<
      UpdateEmploymentHistoryResult,
      QueryError,
      UpdateEmploymentHistoryVariables
    >(
      async ({
        resumeId,
        employmentHistory,
      }: UpdateEmploymentHistoryVariables) => {
        const cid = personalDetails?.traveller?.id;

        if (!cid) throw new Error("cid not found");
        if (!resumeId) throw new Error("resumeId not found");

        const url = `${GATEWAY_URL}/profiles/v2/${cid}/resumes/${resumeId}/employment-history`;

        return fetchWithAuth<UpdateEmploymentHistoryResult>(url, {
          method: "POST",
          body: employmentHistory,
        });
      },
      {
        ...options,
      }
    ),
    cancel,
  };
};

export default useUpdateEmploymentHistoryMutation;
